import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Manual from "./pages/Manual";
import Agents from "./pages/Agents";
import Templates from "./pages/Templates";
import Aliases from "./pages/Aliases";
import Settings from "./pages/Settings";
import History from "./pages/History";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
      <Route path="/manual" element={<Layout><Manual /></Layout>} />
      <Route path="/history" element={<Layout><History /></Layout>} />
      <Route path="/agents" element={<Layout><Agents /></Layout>} />
      <Route path="/templates" element={<Layout><Templates /></Layout>} />
      <Route path="/aliases" element={<Layout><Aliases /></Layout>} />
      <Route path="/settings" element={<Layout><Settings /></Layout>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter basename="/">
      <AppRoutes />
      <Toaster theme="dark" position="top-right" />
    </BrowserRouter>
  );
}
